<footer class="footer bg-white d-flex align-items-center justify-content-end px-6">
    <div class="text-end">
        <div class="fs-12 text-gray-400">v{{ version.time }}</div>
    </div>
</footer>
